import React, { useState, useEffect } from "react";
import {
  GetSinglePlayer,
  selectSinglePlayer,
  selectSinglePlayerLoading,
} from "../state/reducers/SinglePlayerReducer";
import { Game, Match, MatchWithRanks, Player, Rank } from "../types/types";
import { FilterType, GraphType } from "../types/components";
import { TeamsList, TeamLogos } from "../globals/Globals";
import {
  GridColDef,
  GridCellParams,
  GridRowParams,
  GridEvents,
  MuiEvent,
  GridCallbackDetails,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import {
  RenderTeamCellToolTip,
  RenderPriceCell,
  RenderRankCell,
  RenderPositionCell,
} from "../globals/TableFunctions";
import { Container, Box, Tabs, Tab, Paper } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import _ from "underscore";
import GamesHeader from "../components/SinglePlayer/GamesHeader";
import StatsHeadline from "../components/SinglePlayer/StatsHeadLine";
import PlayerDataGrid from "../components/DataGrid/PlayerDataGrid";
import Filter from "../components/Inputs/Filter";
import ChangeAbleGraph from "../components/Graphs/ChangeAbleGraph";
import PredictionsTable from "../components/SinglePlayer/PredictionsTable";
import Trades from "../components/SinglePlayer/Trades";
import PlayerOwnership from "../components/SinglePlayer/PlayerOwnership";
import { PlayerGamesColumns } from "../globals/TableFunctions";
import { CommentBank } from "@mui/icons-material";
import SinglePlayerPerformance from "../components/SinglePlayer/SinglePlayerPerformance";
import { PageContainer } from "../globals/styles";
import PCCContainer from "../components/PriceChangeCalculator/PCCContainer";
import { useAppDispatch, useAppSelector } from "../hooks";
import { useNavigate, useParams } from "react-router-dom";
import MainTables from "../components/SinglePlayer/MainTables";
import PartnerShipsContainer from "../components/SinglePlayer/PartnerShipsContainer";
import OversContainer from "../components/SinglePlayer/OversContainer";
import { IMAGES_BUCKET } from "../configs/consts";
import Loading from "../components/Loading";
import { RegisterEvent, RegisterPageView } from "../globals/Analytics";
import MyTransition from "../components/Theming/MyTransition";
import { CURRENT_SEASON } from "../globals/BBLData";

let basefilters: FilterType[] = [
  {
    options: [
      "2024-25",
      "2023-24",
      "2022-23",
      "2021-22",
      "2020-21",
      "2019-20",
      "Any",
    ],
    name: "Season",
    selected: "2024-25",
    term: "season",
  },
];

const upcomingcolumns: GridColDef[] = [
  { field: "round", headerName: "Round" },
  {
    field: "opponent",
    headerName: "Opponent",
    width: 190,
    renderCell: (params: GridRenderCellParams<Date>) => (
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "38px",
          alignItems: "center",
          background: `linear-gradient(120deg, ${params.row.oppositioncolors[0]} 0%, ${params.row.oppositioncolors[0]} 50%, ${params.row.oppositioncolors[1]} 50%)`,
          color: "white",
        }}
      >
        <img
          style={{ height: "1.5rem", width: "2rem" }}
          src={params.row.opponentlogo}
          alt="Team logo"
        />
        <p>{params.row.opponent}</p>
      </div>
    ),
  },
  { field: "date", headerName: "Date" },
  { field: "location", headerName: "Location", width: 300 },
  // { field: 'ranks', headerName: 'PTS Conceeded Rank', width: 700,
  //     renderCell: (params: GridRenderCellParams<Date>) => (RenderRankCell(params.row.ranks))
  // },
  // { field: 'positionArray', headerName: 'Position', width: 700,
  //     renderCell: (params: GridRenderCellParams<Date>) => (RenderPositionCell(params.row.positions))
  // },
];

const TAB_NAMES = {
  0: "Stats",
  1: "Performance",
  2: "Fixture",
  3: "PCC",
  4: "Trades",
  5: "Ownership",
  6: "Overs",
};

const SinglePlayer = () => {
  let { id } = useParams<{ id: string }>();
  const [animate, setAnimate] = useState(false);
  const [done, setDone] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(GetSinglePlayer(id));
  }, [id]);

  //console.log("single player props: ", props);
  let thePlayer = useAppSelector(selectSinglePlayer);
  let isloading = useAppSelector(selectSinglePlayerLoading) === "loading";

  let player: Player = thePlayer.player;
  let basegames = thePlayer.games;
  let trades = player.trades;
  let stats = player.stats[0];
  let theirstats = player.stats;

  let upcoming = thePlayer.upcoming;
  let dismissals = player.dismissals;
  let overs = player.overs;
  console.log("OVERS: ", overs);
  let datagridrows: object[];
  let upcomingrows: object[];

  const [games, setGames] = useState<Game[]>(basegames);
  const [filteredOvers, setFilteredOvers] = useState(overs);
  const [filters, setFilters] = useState<FilterType[]>(basefilters);
  const [graphGames, setGraphGames] = useState<Game[]>([]);
  const [selectedTab, setSelectedTab] = useState(0);

  let thisteam = stats.lastgame?.team?.name ? stats.lastgame.team.name : "";
  let thisteamobject = stats.lastgame?.team ? stats.lastgame.team : {};
  const playerimg = `${IMAGES_BUCKET}${player.firstname}-${player.lastname}.png`;

  datagridrows = [];
  games.map(function (game, index) {
    let oppositionname = game.opposition?.name ? game?.opposition?.name : "";
    let oppositioncolors: string[] = TeamsList[oppositionname];
    let predictedPriceChange: number =
      game.nextRoundPredictedPrice - game.price;
    let positionsArray: string[] = game.positions.map(function (pos) {
      return pos.name;
    });

    let theTeamLogos = [];
    // if (oppositionname === '' && !game.awayteam) {

    // } else {
    datagridrows.push({
      id: `${game.linkedmatchid}-${index}`,
      season: game.season,
      round: game.round,
      opposition: oppositionname,
      oppositionlogo: TeamLogos[oppositionname],
      points: game.points,
      price: game.price
        ? game.price.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })
        : "",
      price_change: game.price_change,
      position: game.position?.name,
      oppositioncolors: oppositioncolors,
      game: game,
      posrdrank: game.posrdrank,
      postotalrank: game.posrank,
      scbe: game.scbe,
      nextroundpoints: game.nextRoundPredictedPoints,
      nextroundprice: game.nextRoundPredictedPrice,
      predictedPriceChange: predictedPriceChange,
      runs: game.runs,
      fours: game.fours,
      wickets: game.wicketsTaken,
      maiden_overs: game.maiden_overs,
      dotballs: game.dotballs,
      catches: game.catches,
      runouts: game.runouts,
      stumpings: game.stumpings,
      positions: game.positions,
      playerRole: game.playingRoles,
    });
    //}
  });

  upcomingrows = upcoming.map(function (match: MatchWithRanks, index: number) {
    var showteam = "";
    var ranks: Rank[] = [];

    match.teams.map(function (team) {
      if (team.name !== thisteam) {
        showteam = team.name ? team.name : "";
        ranks = team.ranks;
      }
    });

    let oppositioncolors: string[] = TeamsList[showteam]
      ? TeamsList[showteam]
      : [0, 0];
    return {
      id: `${match.round}${showteam}-${index}`,
      round: match.round,
      opponent: showteam,
      opponentlogo: TeamLogos[showteam],
      date: match.date,
      location: match.location,
      oppositioncolors: oppositioncolors,
      ranks: ranks,
    };
  });

  const DoGames = (games: Game[]) => {
    let newgames: Game[] = basegames.slice();
    newgames = _.chain(newgames)
      .filter(function (game) {
        return game.season === filters[0].selected;
      })
      .sortBy("round")
      .sortBy("season")
      .value();
    let changeablegraphsgames: Game[] = [];
    changeablegraphsgames = _.chain(newgames)
      .filter(function (game) {
        return game.season === filters[0].selected;
      })
      .sortBy("round")
      .value();
    setGames(newgames);
    setGraphGames(changeablegraphsgames);
  };

  function DoSort(selecteditem: string, term: string) {
    let newbase = basegames.slice();
    let newgames: Game[] = [];
    var newfilters = filters;
    newbase?.map(function (game) {
      var include = false;
      newfilters.map(function (filter) {
        if (filter.term === term) {
          filter.selected = selecteditem;
        }
        //Check if this filter is filtering
        if (filter.selected !== "Any") {
          include =
            game[filter.term as keyof typeof Object].toString() ===
            filter.selected.toString();
        } else {
          include = true;
        }
      });
      if (include) {
        newgames.push(game);
      }
    });

    newgames = _.chain(newgames).sortBy("round").sortBy("season").value();
    setFilters(newfilters);
    setGames(newgames);
    DoGraphGames();
  }

  const DoGraphGames = () => {
    let newgames: Game[] = basegames.slice();

    newgames = _.chain(newgames).sortBy("round").sortBy("season").value();

    let changeablegraphsgames: Game[] = [];

    changeablegraphsgames = _.chain(newgames)
      .filter(function (game) {
        return game.season === filters[0].selected;
      })
      .sortBy("round")
      .value();

    setGraphGames(changeablegraphsgames);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    RegisterEvent({
      category: "singleplayertoptabchange",
      action: "changetab",
      label: `Changed tab on single player page -> ${TAB_NAMES[newValue]}`,
      value: newValue,
    });
    setSelectedTab(newValue);
  };

  const onCellClick = (
    params: GridCellParams,
    event: MuiEvent<React.MouseEvent>,
    details: GridCallbackDetails
  ) => {
    if (params.field === "navigatebutton") {
      navigate(
        `/match/${params.row.season}/${params.row.round}/${params.row.opposition}`
      );
    }
  };

  useEffect(() => {
    DoSort(CURRENT_SEASON, "season");
    DoGames(games);
  }, []);

  useEffect(() => {
    DoSort(CURRENT_SEASON, "season");
    DoGames(games);
    RegisterPageView({
      path: `/player/${thePlayer.player.firstname}-${thePlayer.player.lastname}`,
    });
  }, [thePlayer]);

  useEffect(() => {}, [games]);
  useEffect(() => {}, [isloading]);
  // if (isloading) {
  //     return <Loading />
  // }
  setTimeout(() => {
    if (!isloading) {
      setAnimate(true);
    }
  }, 500);

  return (
    <div>
      <Loading isLoading={isloading} setDone={setDone} />
      <GamesHeader
        lastmatch={games[games.length - 1]}
        upcoming={upcoming}
        image={playerimg}
        header={player.firstname + " " + player.lastname}
        thisTeam={thisteamobject}
      />
      <PageContainer>
        <StatsHeadline stats={player.stats} player={player} games={games} />
        <MyTransition location="/home" inProp={animate}>
          <Box>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                marginBottom: "1rem",
                display: "flex",
                justifyContent: "center",
                marginTop: "1rem  ",
              }}
            >
              <Tabs
                value={selectedTab}
                onChange={handleChange}
                variant="scrollable"
                style={{ marginBottom: "1rem" }}
              >
                <Tab label="Stats" />
                <Tab label="Performance" />
                <Tab label="Fixture" />
                {/* <Tab label="Price Change Calculator" /> */}
                <Tab label="Trades" />
                <Tab label="Ownership" />
                <Tab label="Overs" />
              </Tabs>
            </Box>

            {selectedTab === 0 ? (
              <div>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-start",
                    marginBottom: "1rem",
                  }}
                >
                  {filters.map(function (filter) {
                    return (
                      <Filter
                        options={filter.options}
                        onChange={DoSort}
                        selected={filter.selected}
                        name={filter.name}
                        term={filter.term}
                      />
                    );
                  })}
                </div>

                <Paper
                  style={{ marginBottom: "1rem", padding: "0.5rem" }}
                  elevation={5}
                >
                  <ChangeAbleGraph
                    defaultGraphItems={["points"]}
                    games={graphGames}
                    title=""
                  />
                </Paper>
                <MainTables
                  games={games}
                  generalColumns={PlayerGamesColumns}
                  generalRows={datagridrows}
                  GeneralonCellClick={onCellClick}
                  player={player}
                />
                {/* <div style={{marginBottom: "1rem", marginTop: '1rem'}}>
                                <PartnerShipsContainer games={basegames} partnerships={player.partnerShips} />
                            </div> */}
                <div>
                  <h4>Predictions</h4>
                  <PredictionsTable games={games} />
                </div>
              </div>
            ) : null}
            {selectedTab === 1 ? (
              <SinglePlayerPerformance games={basegames} />
            ) : null}
            {selectedTab === 2 ? (
              <PlayerDataGrid
                height={450}
                columns={upcomingcolumns}
                rows={upcomingrows}
              />
            ) : null}
            {/* {selectedTab === 3 ? (
              <PCCContainer player={player} games={basegames} />
            ) : null} */}
            {selectedTab === 3 ? (
              <div>
                {" "}
                <Trades trades={trades ? trades : []} />
              </div>
            ) : null}
            {selectedTab === 4 ? (
              <div>
                {" "}
                <PlayerOwnership
                  ownerships={player.ownerships ? player.ownerships : []}
                  lastround={1}
                />
              </div>
            ) : null}
            {selectedTab === 5 ? (
              <OversContainer overs={overs} aboutplayerid={player.id} />
            ) : null}
          </Box>
        </MyTransition>
      </PageContainer>
    </div>
  );
};

export default SinglePlayer;
